import app from 'flarum/forum/app';
import Modal, { IInternalModalAttrs } from 'flarum/common/components/Modal';
import ItemList from 'flarum/common/utils/ItemList';
import PriceOption from './PriceOption';
import type Product from '../../common/Product';
import type Group from 'flarum/common/models/Group';
import type Mithril from 'mithril';

export interface IPaymentOptionsModalAttrs extends IInternalModalAttrs {
  product: Product;
  for: Group;
}

export default class PaymentOptionsModal<CustomAttrs extends IPaymentOptionsModalAttrs = IPaymentOptionsModalAttrs> extends Modal<CustomAttrs> {
  private product!: Product;
  private for!: Group;

  oninit(vnode: Mithril.Vnode<CustomAttrs, this>) {
    super.oninit(vnode);

    this.product = this.attrs.product;
    this.for = this.attrs.for;
  }

  className() {
    return 'PaymentOptionsModal Modal--large';
  }

  title() {
    return app.translator.trans('floxum-payments.forum.payment-options-modal.title', { group: this.for.namePlural() });
  }

  options() {
    let prices = this.product?.attributes?.prices ?? [];
    const options = new ItemList();

    prices = prices instanceof Object ? Object.values(prices) : prices;

    prices.forEach((price) => {
      options.add(price.id, <PriceOption price={price} product={this.product} for={this.for} />);
    });

    return options;
  }

  content() {
    return (
      <div className="Modal-body">
        <div className="Form Form--centered">
          <p className="helpText">{app.translator.trans('floxum-payments.forum.payment-options-modal.description')}</p>
          {this.options().toArray()}
        </div>
      </div>
    );
  }
}
